<template>
  <div class="tyc_order_status" >
    <el-divider content-position="left">订单情况</el-divider>
    <el-row class="mt-10">
      <el-col :span="12">
        <span>{{now}}月份订单数据概况</span>
      </el-col>
      <el-col :span="12" class="tr">
        <el-date-picker
          v-model="search.date"
          size="mini"
          type="month"
          placeholder="选择日期"
          value-format="yyyy-MM"
          @change="handleDateChange">
        </el-date-picker>
        <el-button type="primary" size="mini" @click="handleAddOpen">录入</el-button>
      </el-col>
    </el-row>
    <el-row class="mt-10">
      <el-col :span="24">
        <el-card>
          <div class="charBox" ref="chartbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-table :data="tycOrderStatuses" size="medium"  v-cloak>
      <el-table-column fixed label="日期" prop="status_date"></el-table-column>
      <el-table-column fixed label="全部" prop="order_count"></el-table-column>
      <el-table-column fixed label="未分配" prop="unassigned"></el-table-column>
      <el-table-column fixed label="待服务" prop="to_be_served"></el-table-column>
      <el-table-column fixed label="服务中" prop="serving"></el-table-column>
      <el-table-column fixed label="完成" prop="fulfill"></el-table-column>
      <el-table-column fixed label="退款中" prop="refunding"></el-table-column>
      <el-table-column fixed label="已退款" prop="refunded"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="handleEditOpen(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="添加"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleAddClose"
      size="40%">
      <div class="m-tabs-content">
        <el-row class="mt-10">
          <el-date-picker
            v-model="addData.status_date"
            size="mini"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.unassigned" size="small">
            <template slot="prepend">未分配</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.to_be_served" size="small">
            <template slot="prepend">待服务</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.serving" size="small">
            <template slot="prepend">服务中</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.fulfill" size="small">
            <template slot="prepend">已完成</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.refunding" size="small">
            <template slot="prepend">退款中</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="addData.refunded" size="small">
            <template slot="prepend">已退款</template>
          </el-input>
        </el-row>
        <el-row>
          <el-col :span="24" class="tr">
            <el-button type="primary" size="mini" @click="handleSave">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="upDrawer"
      direction="rtl"
      :before-close="handleUpDateClose"
      size="40%">
      <div class="m-tabs-content">
        <el-row class="mt-10">
          <el-date-picker
            v-model="upData.status_date"
            size="mini"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.unassigned" size="small">
            <template slot="prepend">未分配</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.to_be_served" size="small">
            <template slot="prepend">待服务</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.serving" size="small">
            <template slot="prepend">服务中</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.fulfill" size="small">
            <template slot="prepend">已完成</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.refunding" size="small">
            <template slot="prepend">退款中</template>
          </el-input>
        </el-row>
        <el-row class="mt-10">
          <el-input placeholder="请输入内容" type="number" v-model.number="upData.refunded" size="small">
            <template slot="prepend">已退款</template>
          </el-input>
        </el-row>
        <el-row>
          <el-col :span="24" class="tr">
            <el-button type="primary" size="mini" @click="handleUpdate">保存</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
export default {
  name: 'TycOrderStatus',
  data () {
    return {

      now: '',
      chat: null,
      chatData: [],
      tycOrderStatuses: [],
      search: {
        date: ''
      },
      drawer: false,
      upDrawer: false,
      addData: {
        unassigned: 0,
        to_be_served: 0,
        serving: 0,
        fulfill: 0,
        refunding: 0,
        refunded: 0,
        order_count: 0,
        status_date: ''
      },
      upData: {
        id: null,
        index: null,
        unassigned: 0,
        to_be_served: 0,
        serving: 0,
        fulfill: 0,
        refunding: 0,
        refunded: 0,
        order_count: 0,
        status_date: ''
      }
    }
  },
  computed: {
    addTotal: function () {
      return this.addData.unassigned + this.addData.to_be_served + this.addData.serving + this.addData.fulfill + this.addData.refunding + this.addData.refunded
    },
    upTotal: function () {
      return this.upData.unassigned + this.upData.to_be_served + this.upData.serving + this.upData.fulfill + this.upData.refunding + this.upData.refunded
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    chatData (val) {
      this.initCharts()
    }
  },
  methods: {
    initCharts () {
      this.chart = echarts.init(this.$refs.chartbox, 'light')
      this.setOption()
    },
    setOption () {
      let option = {
        legend: {},
        dataset: {
          source: this.chatData
        },
        xAxis: {type: 'category'},
        yAxis: {
          gridIndex: 0,
          splitLine: {
            show: false
          }
        },
        series: [
          {type: 'line', smooth: true, seriesLayoutBy: 'row'},
          {type: 'line', smooth: true, seriesLayoutBy: 'row'},
          {type: 'line', smooth: true, seriesLayoutBy: 'row'},
          {type: 'line', smooth: true, seriesLayoutBy: 'row'},
          {type: 'line', smooth: true, seriesLayoutBy: 'row'},
          {type: 'line', smooth: true, seriesLayoutBy: 'row'}
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        }
      }
      this.chart.setOption(option)
    },
    getTycOrderStatuses () {
      let url = this.search.date ? '/api/statuses/' + this.search.date : '/api/statuses'
      this.$axios.get(url)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            console.log(data.data.trend)
            this.tycOrderStatuses = data.data.tycOrderStatuses
            this.now = data.data.date
            this.chatData = data.data.trend
          }
        })
    },
    handleDateChange (val) {
      if (!val) {
        this.search.date = ''
      }
      this.getTycOrderStatuses()
    },
    handleAddOpen () {
      this.drawer = true
    },
    handleAddClose (done) {
      this.clearAddData()
      done()
    },
    positiveInteger (num) {
      return /^([1-9]\d*|[0]{1,1})$/.test(num)
    },
    handleSave () {
      if (!this.addData.status_date) {
        this.$message.error('请选择日期')
        return
      }

      if (!this.positiveInteger(this.addData.unassigned)) {
        this.$message.error('未分配的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.addData.to_be_served)) {
        this.$message.error('待服务的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.addData.serving)) {
        this.$message.error('服务中的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.addData.fulfill)) {
        this.$message.error('已完成的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.addData.refunding)) {
        this.$message.error('退款中的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.addData.refunded)) {
        this.$message.error('已完成的值必须是正整数或0')
        return
      }

      this.addData.order_count = this.addTotal

      this.$axios.post('/api/statuses', this.addData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.drawer = false
            this.tycOrderStatuses.unshift(data.data.status)
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearAddData () {
      this.addData.unassigned = 0
      this.addData.to_be_served = 0
      this.addData.serving = 0
      this.addData.fulfill = 0
      this.addData.refunding = 0
      this.addData.refunded = 0
      this.addData.status_date = ''
    },
    handleEditOpen (index, row) {
      this.upData.id = row.id
      this.upData.index = index
      this.upData.unassigned = row.unassigned
      this.upData.to_be_served = row.to_be_served
      this.upData.serving = row.serving
      this.upData.fulfill = row.fulfill
      this.upData.refunding = row.refunding
      this.upData.refunded = row.refunded
      this.upData.status_date = row.status_date
      this.upDrawer = true
    },
    handleUpdate () {
      if (!this.upData.status_date) {
        this.$message.error('请选择日期')
        return
      }

      if (!this.positiveInteger(this.upData.unassigned)) {
        this.$message.error('未分配的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.upData.to_be_served)) {
        this.$message.error('待服务的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.upData.serving)) {
        this.$message.error('服务中的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.upData.fulfill)) {
        this.$message.error('已完成的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.upData.refunding)) {
        this.$message.error('退款中的值必须是正整数或0')
        return
      }

      if (!this.positiveInteger(this.upData.refunded)) {
        this.$message.error('已完成的值必须是正整数或0')
        return
      }

      this.upData.order_count = this.upTotal

      this.$axios.put('/api/statuses/' + this.upData.id, this.upData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.singleRefresh(data.data)
            this.upDrawer = false
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    singleRefresh (data) {
      this.tycOrderStatuses[this.upData.index].order_count = data.order_count
      this.tycOrderStatuses[this.upData.index].unassigned = data.unassigned
      this.tycOrderStatuses[this.upData.index].to_be_served = data.to_be_served
      this.tycOrderStatuses[this.upData.index].serving = data.serving
      this.tycOrderStatuses[this.upData.index].fulfill = data.fulfill
      this.tycOrderStatuses[this.upData.index].refunding = data.refunding
      this.tycOrderStatuses[this.upData.index].refunded = data.refunded
      this.tycOrderStatuses[this.upData.index].status_date = data.status_date
    },
    handleUpDateClose (done) {
      this.clearUpdateData()
      done()
    },
    clearUpdateData () {
      this.upData.id = null
      this.upData.index = null
      this.upData.unassigned = 0
      this.upData.to_be_served = 0
      this.upData.serving = 0
      this.upData.fulfill = 0
      this.upData.refunding = 0
      this.upData.refunded = 0
      this.upData.status_date = ''
    }
  },
  mounted () {
    this.getTycOrderStatuses()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  [v-cloak]
    display: none;
  .tyc_order_status >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .tyc_order_status
    marginLeft()
    .charBox
      width: 100%
      height: 6rem
  .tr
    text-align: right
  .mt-10
    margin-bottom: .2rem
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order_status/TycOrderStatus.vue